import { languages } from "../languages";

//English
const location_en = "Moncton";
const locale_en = "en-MO";
const language_en = languages[locale_en.slice(0,2)](location_en)
const slugs_en = language_en.slugs;
const messages_en = language_en.messages;

//French
const location_fr = "Moncton";
const locale_fr = "fr-MO";
const language_fr = languages[locale_fr.slice(0,2)](location_fr)
const slugs_fr = language_fr.slugs;
const messages_fr = language_fr.messages;


const contactInfo = {
  "contact-info.telephone-number": "1-506-801-2482",
  "contact-info.email": "moncton@andmar.ca",
}

const customData = {
  "PresentationImage":"MonctonPresentation",
}


export const moncton = {
  en:{
    locale:locale_en,
    prefix: `${location_en.toLowerCase().replace(/\s/g, '')}/${locale_en.slice(0,2)}`,//moncton/en
    slugs: {...slugs_en},
    messages: {...messages_en, ...contactInfo, ...customData},
  },
  fr:{
      locale:locale_fr,
      prefix: `${location_fr.toLowerCase().replace(/\s/g, '')}/${locale_fr.slice(0,2)}`,//moncton/fr
      slugs: {...slugs_fr},
      messages: {...messages_fr, ...contactInfo, ...customData},
    }
};


